import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import ButtonBackPage from "@components/ButtonBackPage";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { Box, Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import Navigation from "@pages/Contents/Corporate/CollectCampaigns/components/navigation/Navigation";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCollectCampaignState } from "../context/CollectCampaignContext";

const AddCollectCampaign: React.FC<{ page: PagesID }> = ({ page }) => {
  const { t } = useTranslation(["collect-campaign-page"]);
  const { id } = useParams();
  const navigate = useNavigate();
  const { state, dispatch } = useCollectCampaignState();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const steps = [t("general"), t("owners"), t("lo"), t("users"), t("template")];
  const theme = useTheme();

  const isLargeScreen = useMediaQuery(theme.breakpoints.down("xl"));

  const { columns, mutate } = useFetchTable(
    `${ServicesURL.findCampaignsAdmin.replace(":corporateId", id ? id : "1")}`,
    PagesID["corporate.collect-campaign.add"],
  );

  return (
    <AnimationFadeIn>
      {/* <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-survey.jpg"
        position={"absolute"}
        fullpage={true}
      /> */}
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <ButtonBackPage />
          <Grid container>
            <Grid
              item
              lg={12}
              xl={12}
              sx={{
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  // backgroundColor: theme.palette.background.paper,
                  // padding: "32px",
                  // minHeight: "495px",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Navigation
                  steps={steps}
                  columns={columns}
                  onComplete={async () => {
                    await mutate();
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <ModalConfirmsCst
          open={!!openToast}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => {
            navigate(`/corporate/${+id! || 1}/detail/collect-campaigns`);
          }}
          onActionConfirmed={() => {
            navigate(`/corporate/${+id! || 1}/detail/collect-campaigns`);
          }}
          status={openToast}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default AddCollectCampaign;
